<template>
  <div class="metafield-edit-url">
    <BaseInput
      :data-vv-as="field.type"
      :name="$attrs.name"
      :value="value"
      :label="field.label"
      :hint="hint"
      @input="onInput"
      validate="url"
      ></BaseInput>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  inject: ['$validator'],
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    value: String,
    hint: String
  },
  methods: {
    onInput (val) {
      this.$emit('input', val === '' ? null : val)
    }
  },
}
</script>

<style lang="scss">
  .metafield-edit-url {

  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditUrl.vue